/**
 * Module dependencies.
 */

import { Menu } from 'components/atoms/menu/menu';
import styled from '@emotion/styled';

/**
 * Export `HamburgerWrapper` styled component.
 */

export const HamburgerWrapper = styled.div`
  display: none;
  min-width: auto;
  padding: 8px;
  color: white;
  min-width: auto;
  margin-top: 10px;
  left: 16px;
  position: relative;

  @media (max-width: 820px) {
    display: flex;
    margin-top: 19px;
  }

  @media (max-width: 768px) {
    display: flex;
    margin-top: 19px;
  }

  @media (max-width: 576px) {
    margin-top: 26px;
  }
`;

/**
 * Export `NavBarMenu` styled component.
 */

export const NavBarMenu = styled(Menu)`
  @media (max-width: 768px) {
    display: none;
    flex-direction: column;
    width: 100%;
    background: #222;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 16px;
    z-index: 2000;

    &.open {
      display: flex;
    }
  }
`;
